export default __webpack_public_path__ + "plus-sign-in-a-black-circle.png";